var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEarthAfrica = function SvgEarthAfrica(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.875,
    d: "m15.915 10.086-.882-.883a1.8 1.8 0 0 1-.328-.455l-.84-1.68a.323.323 0 0 0-.516-.083.64.64 0 0 1-.631.163l-.99-.282a.692.692 0 0 0-.574 1.24l.456.304a.876.876 0 0 1 .134 1.347l-.155.155a.88.88 0 0 0-.257.62v.318c0 .318-.086.63-.249.9l-1.023 1.705a1.64 1.64 0 0 1-1.408.797.82.82 0 0 1-.82-.82v-.912a1.75 1.75 0 0 0-1.1-1.625l-.51-.203A1.75 1.75 0 0 1 5.148 8.78l.005-.033a1.8 1.8 0 0 1 .226-.612l.07-.116a1.75 1.75 0 0 1 1.843-.816l.917.184a.875.875 0 0 0 1.012-.618l.162-.568a.875.875 0 0 0-.45-1.023l-.517-.258-.07.07a1.75 1.75 0 0 1-1.238.513h-.14a.73.73 0 0 0-.515.213.724.724 0 0 1-1.134-.884l1.098-1.83a1.8 1.8 0 0 0 .222-.591m9.277 7.676a7 7 0 1 0-13.83-2.173 7 7 0 0 0 13.83 2.172Z"
  })));
};
export default SvgEarthAfrica;